export default __webpack_public_path__ + "static/media/i050hp.d8b86d29.webp";